import Lpntable from './Components/Lpn-table'
import Header from '../../../Components/Header'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const CustomerRepair = () => {
   const location = useLocation();
  return (
        <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
        <Helmet>
				    <title>Customer Repair List</title>
			  </Helmet>
        <Header />
        <Lpntable />
    </div>
  )
}

export default CustomerRepair